<div class="overlap_panel_wrapper">
  <div class="overlap_panel_sidebar">
    <div class="side_header">
      <div class="cross_wrap">
        <a href="javascript:void(0);" (click)="close()">
          <img src="../../../../assets/img/cross_icon.svg" alt="" class="icon">
        </a>
      </div>
      <p class="company_name">Bid Detail</p>
      <div class="back_wrap">
        @if (stepper.selectedIndex > 0) {
          <a (click)="goBack(stepper)" class="back-button">
            <img src="../../../../assets/img/left_orange_arrow.svg" alt="Back" class="arrow">
            <span>Back</span>
          </a>
        }
      </div>
    </div>
    <div class="sidebar_accordion">
      <app-bid-step-preview [model]="model" [isEdit]="isEdit" [step]="step" [form]="bidForm"></app-bid-step-preview>
    </div>
  </div>
  <div class="overlap_right_panel">
    <form [formGroup]="bidForm" novalidate>
      <mat-horizontal-stepper #stepper [linear]="true" (selectionChange)="onStepChanged($event, stepper)">
        <mat-step formGroupName="step01" [stepControl]="bidForm.get('step01')!">
          <ng-template matStepLabel>Bid Detail</ng-template>
          <app-bid-detail-form [DefaultContactId]="defaultContactId" [DefaultCustomerId]="defaultCustomerId"
            [defaultDate]="isFromCalendar ? defaultDate : null" [defaultTime]="isFromCalendar ? defaultTime : null"
            [isFromCalendar]="isFromCalendar" [isCellClick]="isCellClick" (callback)="changedHandler($event)"
            [isEdit]="isEdit" formControlName="bidDetail" [form]="bidForm.get('step01')"
          [model]="model"></app-bid-detail-form>
          <div class="controls">
            <button type="button" mat-button class="btn_transparent" (click)="close()">Cancel</button>
            <button mat-button matStepperNext (click)="touchFormControls('step01')" class="btn_solid_color">Next <img
            src="../../../../assets/img/btn_arrow.png" alt="icon" class="icon"></button>
          </div>
        </mat-step>
        <mat-step formGroupName="step02" [stepControl]="bidForm.get('step02')!">
          <ng-template matStepLabel>Scopes/Stage</ng-template>
          <app-scope-stage-form (callback)="changedHandler($event)" [isEdit]="isEdit" formControlName="scopesStage"
          [form]="bidForm.get('step02')" [model]="model"></app-scope-stage-form>
          <div class="controls">
            <button mat-button matStepperPrevious class="btn_transparent">Back</button>
            <button type="button" mat-button matStepperNext (click)="touchFormControls('step02')"
              class="btn_solid_color">Next <img src="../../../../assets/img/btn_arrow.png" alt="icon"
            class="icon"></button>
          </div>
        </mat-step>
        <mat-step formGroupName="step03" [stepControl]="bidForm.get('step03')!">
          <ng-template matStepLabel>Assignment</ng-template>
          <app-assignment-form (callback)="changedHandler($event)" [isEdit]="isEdit" formControlName="assignment"
            [bidDetailForm]="bidForm.get('step01')" [form]="bidForm.get('step03')"
          [model]="model"></app-assignment-form>
          <div class="controls">
            <button mat-button matStepperPrevious class="btn_transparent">Back</button>
            <button type="button" mat-button matStepperNext (click)="touchFormControls('step03')"
              class="btn_solid_color">Next <img src="../../../../assets/img/btn_arrow.png" alt="icon"
            class="icon"></button>
          </div>
        </mat-step>
        <mat-step formGroupName="step04" [stepControl]="bidForm.get('step04')!">

          <ng-template matStepLabel>Jobsite Address </ng-template>

          <app-jobsite-address-form (callback)="changedHandler($event)" [isEdit]="isEdit"
            formControlName="jobsiteAddressDetail" [form]="bidForm.get('step04')"
          [model]="model" [defaultJobsiteName]="bidForm.get('step01')?.get('bidDetail')?.value?.name"></app-jobsite-address-form>
          <div class="controls">
            <button mat-button matStepperPrevious class="btn_transparent">Back</button>
            <button type="button" mat-button matStepperNext (click)="touchFormControls('step04')"
              class="btn_solid_color">Next <img src="../../../../assets/img/btn_arrow.png" alt="icon"
            class="icon"></button>
          </div>
        </mat-step>

        <mat-step formGroupName="step05" [stepControl]="bidForm.get('step05')!">
          <ng-template matStepLabel>Preview</ng-template>
          <app-bid-final-preview [isEdit]="isEdit" [model]="model" [form]="bidForm"></app-bid-final-preview>
          <div class="controls">
            <button mat-button matStepperPrevious class="btn_transparent">Back</button>
            <button mat-button [disabled]="bidForm?.invalid || isSaving" (click)="onSubmit()" class="btn_solid_color">
              @if (isSaving) {
                <mat-progress-spinner  diameter="16" strokeWidth="3" mode="indeterminate" color="accent"
                  class="btn-spinner mr-3">
                </mat-progress-spinner>
              }
              <span class="btn-label">{{model ? 'Update' : 'Create'}}</span>
            </button>
          </div>
        </mat-step>
      </mat-horizontal-stepper>
    </form>
  </div>
</div>